import { inject, Injectable } from '@angular/core';

import { useFirmwareStore } from '../../../+state/firmware-package/firmware-api.store';
import {
  FirmwareUploadResponseDto,
  PackageUpdateRequestBody
} from '../../../infrastructure/backends/firmware-upload-package.dto';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  private store = inject(useFirmwareStore);

  uploadFirmwareFile(file: File, metadata: FirmwareUploadResponseDto) {
    return this.store.uploadFirmwarePackage(file, metadata);
  }

  updateFirmwarePackage(packageId: number, metadata: PackageUpdateRequestBody) {
    return this.store.updateFirmwarePackage(packageId, metadata);
  }
}
